import React from "react";
import { motion } from "framer-motion";
import { CornerDownRight, ChevronsRight } from "lucide-react";
import about_bg from "../../assets/case_study.png";
import { Link } from "react-router-dom";
const CasestudyBanner = () => {
  return (
    <section className="relative w-full bg-[#f7f7f5] text-slate-900 overflow-hidden flex items-end pt-36 pb-16 md:pt-44 md:pb-28">
      <div
        className="pointer-events-none w-1/3 top-0 left-0  absolute
        h-auto opacity-15 select-none"
      >
        <img
          src={about_bg}
          alt=""
          className="w-full  object-cover"
        />
      </div>
    
      <div className="mx-auto max-w-7xl flex justify-center items-center px-6  lg:px-12 relative z-10 w-full">
        <div className="max-w-3xl">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="text-balance text-center text-4xl sm:text-6xl md:text-7xl font-semibold tracking-tight text-slate-950  "
          >Case{" "}
            <span className="font-serif italic font-light text-slate-500">
              Studies
            </span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
            className="mt-6 text-lg sm:text-xl text-center text-slate-600 max-w-2xl leading-relaxed"
          >
            Explore real-world success stories, proven strategies, and the impact we’ve created for our clients.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
            className="mt-6 text-base text-slate-500  flex flex-row justify-center gap-1 items-center leading-relaxed"
          >
            <Link to="/">Home</Link> <ChevronsRight size={20} /> Case Studies
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            className="mt-7 pt-6 border-t border-slate-300/80 flex items-center justify-center gap-3 text-xs font-mono text-slate-500 tracking-widest uppercase"
          >
            <CornerDownRight size={14} className="text-slate-950" />
            <span>Discover the stories, strategies, and results</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CasestudyBanner;
